(function () {
	const grid_el = document.getElementById(`js-hub-locations`);
	if (!grid_el) {
		return;
	}

	const item_els = grid_el.querySelectorAll(`.locations-item`);

	let user_toggled = false;

	function column_count() {
		const tracks = window.getComputedStyle(grid_el).gridTemplateColumns;

		return tracks.trim().split(/\s+/).length;
	}

	function set_state(item_el, open) {
		item_el.classList.toggle(`open`, open);

		const toggle_el = item_el.querySelector(`.locations-toggle`);

		if (toggle_el) {
			toggle_el.setAttribute(`aria-expanded`, open ? `true` : `false`);
		}
	}

	function apply_default_open() {
		const count = column_count();

		item_els.forEach((item_el, index) => {
			set_state(item_el, index < count);
		});
	}

	grid_el.addEventListener(`click`, (event) => {
		const toggle_el = event.target.closest(`.locations-toggle`);
		if (!toggle_el) {
			return;
		}

		const item_el = toggle_el.closest(`.locations-item`);
		if (!item_el) {
			return;
		}

		user_toggled = true;

		set_state(item_el, !item_el.classList.contains(`open`));
	});

	apply_default_open();

	let resize_timer = null;

	window.addEventListener(`resize`, () => {
		if (user_toggled) {
			return;
		}

		window.clearTimeout(resize_timer);
		resize_timer = window.setTimeout(apply_default_open, 200);
	});
})();
